var _path, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 16,
    viewBox: "0 0 148 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.904 14V12.096H0.8V10.296L4.488 2.48H6.688L3 10.296H5.904V7.296H7.856V10.296H8.936V12.096H7.856V14H5.904ZM10.8619 14V12.024H12.8379V14H10.8619ZM18.8173 14.24C18.2306 14.24 17.6839 14.12 17.1773 13.88C16.6706 13.6347 16.2333 13.2987 15.8653 12.872C15.5026 12.4453 15.2413 11.9493 15.0813 11.384L16.9373 10.888C17.0119 11.1973 17.1479 11.464 17.3453 11.688C17.5479 11.912 17.7826 12.0853 18.0493 12.208C18.3213 12.3307 18.6013 12.392 18.8893 12.392C19.2626 12.392 19.6039 12.3013 19.9133 12.12C20.2226 11.9387 20.4679 11.696 20.6493 11.392C20.8306 11.0827 20.9213 10.7413 20.9213 10.368C20.9213 9.99467 20.8279 9.656 20.6413 9.352C20.4599 9.04267 20.2146 8.8 19.9053 8.624C19.5959 8.44267 19.2573 8.352 18.8893 8.352C18.4466 8.352 18.0786 8.432 17.7853 8.592C17.4973 8.752 17.2759 8.92267 17.1213 9.104L15.4733 8.576L15.8253 2.48H22.0813V4.288H16.8573L17.5773 3.608L17.3213 7.848L16.9693 7.416C17.2679 7.144 17.6146 6.94133 18.0093 6.808C18.4039 6.67467 18.7853 6.608 19.1533 6.608C19.8733 6.608 20.5106 6.77333 21.0653 7.104C21.6253 7.42933 22.0626 7.87467 22.3773 8.44C22.6973 9.00533 22.8573 9.648 22.8573 10.368C22.8573 11.088 22.6706 11.7413 22.2973 12.328C21.9239 12.9093 21.4306 13.3733 20.8173 13.72C20.2093 14.0667 19.5426 14.24 18.8173 14.24Z",
    fill: "#FFBF00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6116 14.9435C39.2256 15.1415 38.7876 14.7945 38.8656 14.3515L39.6956 9.6215L36.1726 6.2655C35.8436 5.9515 36.0146 5.3775 36.4556 5.3155L41.3536 4.6195L43.5376 0.2925C43.7346 -0.0975 44.2676 -0.0975 44.4646 0.2925L46.6486 4.6195L51.5466 5.3155C51.9876 5.3775 52.1586 5.9515 51.8286 6.2655L48.3066 9.6215L49.1366 14.3515C49.2146 14.7945 48.7766 15.1415 48.3906 14.9435L43.9996 12.6875L39.6106 14.9435H39.6116Z",
    fill: "#FFBF00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6116 14.9435C65.2256 15.1415 64.7876 14.7945 64.8656 14.3515L65.6956 9.6215L62.1726 6.2655C61.8436 5.9515 62.0146 5.3775 62.4556 5.3155L67.3536 4.6195L69.5376 0.2925C69.7346 -0.0975 70.2676 -0.0975 70.4646 0.2925L72.6486 4.6195L77.5466 5.3155C77.9876 5.3775 78.1586 5.9515 77.8286 6.2655L74.3066 9.6215L75.1366 14.3515C75.2146 14.7945 74.7766 15.1415 74.3906 14.9435L69.9996 12.6875L65.6106 14.9435H65.6116Z",
    fill: "#FFBF00"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6116 14.9435C91.2256 15.1415 90.7876 14.7945 90.8656 14.3515L91.6956 9.6215L88.1726 6.2655C87.8436 5.9515 88.0146 5.3775 88.4556 5.3155L93.3536 4.6195L95.5376 0.2925C95.7346 -0.0975 96.2676 -0.0975 96.4646 0.2925L98.6486 4.6195L103.547 5.3155C103.988 5.3775 104.159 5.9515 103.829 6.2655L100.307 9.6215L101.137 14.3515C101.215 14.7945 100.777 15.1415 100.391 14.9435L95.9996 12.6875L91.6106 14.9435H91.6116Z",
    fill: "#FFBF00"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.612 14.9435C117.226 15.1415 116.788 14.7945 116.866 14.3515L117.696 9.6215L114.173 6.2655C113.844 5.9515 114.015 5.3775 114.456 5.3155L119.354 4.6195L121.538 0.2925C121.735 -0.0975 122.268 -0.0975 122.465 0.2925L124.649 4.6195L129.547 5.3155C129.988 5.3775 130.159 5.9515 129.829 6.2655L126.307 9.6215L127.137 14.3515C127.215 14.7945 126.777 15.1415 126.391 14.9435L122 12.6875L117.611 14.9435H117.612Z",
    fill: "#FFBF00"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.612 14.9435C143.226 15.1415 142.788 14.7945 142.866 14.3515L143.696 9.6215L140.173 6.2655C139.844 5.9515 140.015 5.3775 140.456 5.3155L145.354 4.6195L147.538 0.2925C147.735 -0.0975 148.268 -0.0975 148.465 0.2925L150.649 4.6195L155.547 5.3155C155.988 5.3775 156.159 5.9515 155.829 6.2655L152.307 9.6215L153.137 14.3515C153.215 14.7945 152.777 15.1415 152.391 14.9435L148 12.6875L143.611 14.9435H143.612Z",
    fill: "#FFBF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(62)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(88)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(114)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 16,
    fill: "white",
    transform: "translate(140)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartCourse);
export default __webpack_public_path__ + "static/media/start_course.0f93f3a4a6f81919750c082b17997dd1.svg";
export { ForwardRef as ReactComponent };